import { render } from "./section7.vue?vue&type=template&id=9611c33e&scoped=true"
const script = {}

import "./section7.vue?vue&type=style&index=0&id=9611c33e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9611c33e"]])

export default __exports__